export const OPEN_VIDEO_PAUSE_DIALOG_PARTICIPANT = 'OPEN_VIDEO_PAUSE_DIALOG_PARTICIPANT';

export const HIDE_VIDEO_PAUSE_DIALOG_PARTICIPANT = 'HIDE_VIDEO_PAUSE_DIALOG_PARTICIPANT';

export const RESET_TIMER_TO_TEN_MINUTES = 'RESET_TIMER_TO_TEN_MINUTES';

export const RESET_TIMER_TO_FORTYFIVE_MINUTES = 'RESET_TIMER_TO_FORTYFIVE_MINUTES';

export const SET_COUNT_DOWN_TIME = 'SET_COUNT_DOWN_TIME';

export const SET_PROGRESS = 'SET_PROGRESS';

export const SET_IS_RED_CIRCLE = 'SET_IS_RED_CIRCLE';

export const SET_TIMER_COUNT_DOWN_INTERVAL = 'SET_TIMER_COUNT_DOWN_INTERVAL';

export const CLEAR_TIMER_COUNT_DOWN_INTERVAL = 'CLEAR_TIMER_COUNT_DOWN_INTERVAL';

export const SET_PROGRESS_TEXT = 'SET_PROGRESS_TEXT';

export const SET_CURRENT_TIME = 'SET_CURRENT_TIME';

export const LONG_PRESS_BUTTON = 'LONG_PRESS_BUTTON';
